var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoupe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10777",
    "data-name": "Grupo 10777",
    transform: "translate(-37 -480)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10778",
    "data-name": "Grupo 10778"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_96",
    "data-name": "Elipse 96",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(37 480)",
    fill: "#3a87d9",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1565",
    "data-name": "Trazado 1565",
    d: "M23,0A23,23,0,1,1,0,23,23,23,0,0,1,23,0Z",
    transform: "translate(44 487)",
    fill: "#3a87d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-search",
    "data-name": "Icon map-search",
    d: "M18.5,15.394a9.218,9.218,0,1,0-3.1,3.1l6.254,6.254,3.1-3.1Zm-7.859.933a5.686,5.686,0,1,1,5.689-5.683,5.7,5.7,0,0,1-5.689,5.683Z",
    transform: "translate(53.56 496.56)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoupe);
export default __webpack_public_path__ + "static/media/loupe.67652dbf0a9fd35da755863aa16da65b.svg";
export { ForwardRef as ReactComponent };